import { fetchFromApi } from '@classic/Foundation/Services/ApiService'
import type { TrendingBetsQueryResponse } from '../types'

export const getTrendingBets = async (
  sortingOptions?: string[]
): Promise<TrendingBetsQueryResponse> => {
  let url = '/api/search/trendingBets'
  if (sortingOptions && sortingOptions.length) url += `?${sortingOptions.join('&')}`
  const results = await fetchFromApi(url)
  return await results.json()
}
